const warningInitialState = {
  open: false,
  message: null,
  poppedup: false,
};

export const warningReducer = (state = warningInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_WARNING_MESSAGE":
      return {
        ...state,
        open: true,
        message: payload.message,
      };

    case "DISMISS_WARNING_MESSAGE":
      return {
        ...state,
        open: false,
      };

    case "SET_WARNING_POPPEDUP":
      return {
        ...state,
        poppedup: true,
      };

    default:
      return state;
  }
};
